import { Link } from "react-router-dom";
import { Reveal, SectionHead } from "@/components/Reveal";
import { WORK_STEPS } from "@/data/content";
import { btnPrimary } from "@/lib/ui";
import { ArrowRight } from "lucide-react";

export const WorkMethod = ({ compact = false }) => (
  <section className="py-24 md:py-36" data-testid="work-method-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
      <SectionHead nr="07" overline="Onze werkwijze" title="Van risicoanalyse tot werkend alarmscenario" />
      <div className="mt-14 grid gap-6 md:grid-cols-2 xl:grid-cols-3">
        {WORK_STEPS.map((step, i) => (
          <Reveal key={step.nr} delay={(i % 3) * 0.1} className="h-full">
            <article className="relative h-full rounded-2xl border border-white/10 bg-[#10232F]/40 p-7 transition-[border-color] duration-500 hover:border-[#62C3F0]/40">
              <span className="font-heading text-4xl font-extrabold text-[#2B9FD7]/25">{step.nr}</span>
              <h3 className="mt-3 font-heading text-base font-bold text-[#F5F7F9]">{step.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-[#CBD3D9]/85">{step.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
      {!compact && (
        <Reveal delay={0.2} className="mt-14">
          <Link to="/offerte" className={btnPrimary} data-testid="workmethod-cta">
            Plan een locatieanalyse <ArrowRight size={16} />
          </Link>
        </Reveal>
      )}
    </div>
  </section>
);
